module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('div', {
    staticClass: "quote sans",
    attrs: {
      "id": "c01"
    }
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src208"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _vm._v("You ought to be out raising hell. This is the fighting age. Put on your fighting clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Mother Jones")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src107"
    }
  }, [_vm._v("Living is a form of not being sure, not knowing what next or how. The moment you know how, you begin to die a little.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Agnes de Mille")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src359"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _vm._v("Every word a woman writes changes the story of the world, revises the official version.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Carolyn See")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src356"
    }
  }, [_vm._v("I thank you trolls so much. It fills me with hope and power to see you all furiously posting, so as always accuse me of whatever lies you want. Call me a whale. Call me a thief, and I will continue to rise and fight and lead.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Amy Schumer")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src407"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("I don’t want "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("happy-face")])]), _vm._v(" conclusions. I want the "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("TRUTH")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Warren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src213"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("Avoiding danger is no safer in the long run than outright exposure. The fearful are caught as often as the bold.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Keller")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src394"
    }
  }, [_vm._v("I was the conductor of the Underground Railroad for eight years, and I can say what most conductors can’t say—I never ran my train off the track, and I never lost a passenger.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Harriet Tubman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src109"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("What matters in a character is not whether one holds this or that opinion: what matters is how proudly one upholds it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Germaine de Staël")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src5"
    }
  }, [_vm._v("I like to help women help themselves, as that is, in my opinion, the best way to settle the woman question. Whatever we can do and do well, we have a right to, and I don’t think anyone will deny us.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Louisa May Alcott")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src205"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("A little stress "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("and adventure")])]), _vm._v(" is good for you, if nothing else, just to prove "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("YOU ARE ALIVE")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Lady Bird Johnson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src142"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("I don’t look at what I’ve lost. I look instead at what I have left.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Betty Ford")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src154"
    }
  }, [_vm._v("People thought I was ruthless, which I was. I didn’t give a darn who was on the other side of the net. I’d knock you down if you got in my way.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Althea Gibson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src402"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("When a woman becomes her own best friend, life is easier.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Diane von Fürstenberg")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src346"
    }
  }, [_vm._v("Hard work keeps the wrinkles out of the mind and spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Helena Rubinstein")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src185"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("I did what my conscience told me to do, and you can’t fail if you do that.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Anita Hill")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src151"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("A woman with a voice is by definition a strong woman. But the search to find that voice can be remarkably difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Melinda Gates")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src305"
    }
  }, [_vm._v("I have learned over the years that when one’s mind is made up, this diminishes fear; knowing what must be done does away with fear.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Rosa Parks")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src183"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("Nothing is impossible; the word itself says “I’m possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Audrey Hepburn")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src202"
    }
  }, [_vm._v("Love bravely, live bravely, be courageous—there’s really nothing to lose. There’s no wrong you can’t make right again, so be kind to yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Jewel")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src403"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("The most common way people give up their power is by thinking they don’t have any.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Alice Walker")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src311"
    }
  }, [_vm._v("A strong woman is a woman determined to do something others are determined not to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Marge Piercy")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src436"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('strong', [_vm._v("We realize the importance of our voices only when we are silenced.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Malala Yousafzai")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src384"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('strong', [_vm._v("You can’t always be the strongest or most talented person in the room, but you can be the most competitive.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Pat Summitt")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("I simply ache from smiling. Why are women expected to beam all the time? It’s unfair. If a man looks solemn, it’s automatically assumed he’s a serious person, not a miserable one.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Elizabeth II")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src81"
    }
  }, [_vm._v("Be as bold as the first man or woman to eat an oyster.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Shirley Chisholm")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src306"
    }
  }, [_vm._v("I’ve never asked for special treatment along the way. And I’m never going to hide the fact that I’m a girl, ever. That’s obvious, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Danica Patrick")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src61"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("The reward for conformity is that everyone likes you except yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Rita Mae Brown")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src179"
    }
  }, [_vm._v("Your job is to be you, which includes being the chief beneficiary of all things you do right, the chief victim of all you do wrong, and the one person on Earth who has to live with every choice you make. As gatekeeper to your life, you’re it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Carolyn Hax")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src149"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("Social change is brought about by those "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("who dare and act")])]), _vm._v(", who can think "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("UNCONVENTIONALLY")]), _vm._v(", and who can court unpopularity.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Indira Gandhi")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src126"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('strong', [_vm._v("If you don’t have a seat at the table, you’re probably on the menu.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Warren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src264"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("Don’t be so humble; you aren’t that great.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Golda Meir")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src194"
    }
  }, [_vm._v("Sometimes I feel discriminated against, but it does not make me angry. It merely astonishes me. How can anyone deny themselves the pleasure of my company? It’s beyond me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Zora Neale Hurston")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src153"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("You can never leave footprints that last if you are always walking on tiptoe.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Leymah Gbowee")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src330"
    }
  }, [_vm._v("I firmly believe you never should spend your time being the former anything.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Condoleezza Rice")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src352"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("Woman must not accept; she must challenge. She must not be told how to use her freedom; she must find out for herself. She must not be awed by that which has been built up around her; she must reverence that within her which struggles for expression.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Sanger")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src114"
    }
  }, [_vm._v("The willingness to accept responsibility for one’s own life is the source from which self-respect springs.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Joan Didion")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src295"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('strong', [_vm._v("One of the lessons that I grew up with was to always "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("stay true to yourself")]), _vm._v(" and never let what somebody else says distract you from your "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("goals. And so when I hear about negative and false attacks, I really don’t invest any energy in them, because "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("I know who I am.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Michelle Obama")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src96"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v("Changing the world doesn’t happen all at once. It isn’t a big bang. It’s an evolution, the sum of a billion tiny sparks. And some of those sparks will have to come from you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Katie Couric")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src66"
    }
  }, [_vm._v("Women with money and women in power are two uncomfortable ideas in our society.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Candace Bushnell")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src401"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v("The important thing is not what they think of me, but what I think of them.")]), _vm._v(" "), _c('p', {
    staticClass: "auth31 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Victoria")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src72"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("There are some things you learn best in "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("calm")])]), _vm._v(", and some in "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("STORM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Willa Cather")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src266"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v("The eagle has no fear of adversity. We need to be like the eagle and have a fearless spirit of a conqueror.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Joyce Meyer")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src258"
    }
  }, [_vm._v("I don’t have any option. I’m not going to be less gay or more pretty. I can’t try to have less personality or fewer controversial opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Rachel Maddow")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src104"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v("We don’t develop courage by being happy every day. We develop it by surviving difficult times and challenging adversity.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara De Angelis")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src410"
    }
  }, [_vm._v("Don’t live down to expectations. Go out there and do something remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Wendy Wasserstein")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('strong', [_vm._v("I love to see a young girl go out and grab the world by the lapels. "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Life’s a bitch.")]), _vm._v(" You’ve got to go out and kick ass.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Maya Angelou")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src269"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v("It is not true that life is one damn thing after another; it’s one damn thing over and over.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Edna St. Vincent Millay")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src20"
    }
  }, [_vm._v("I hate to hear you talk about all women as if they were fine ladies instead of rational creatures. None of us want to be in calm waters all our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Jane Austen")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src28"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('strong', [_vm._v("Beautiful? It’s all a question of luck. I was born with good legs. As for the rest . . . beautiful, no. Amusing, yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Josephine Baker")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src212"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("At the end of the day, we can "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("endure")])]), _vm._v(" "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("much more")])]), _vm._v(" than we think we can.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Frida Kahlo")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src99"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _vm._v("A common misconception about strong women is that we don’t need the hand-holding, the flowers, and the nice gestures, and what I’ve found to be true is that it’s the strong women who want it the most.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Nicole Curtis")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src33"
    }
  }, [_vm._v("If anger were mileage, I’d be a very frequent flyer, right up there in first class.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gina Barreca")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src195"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _vm._v("So keep fightin’ for freedom and justice, beloveds, but don’t you forget to have fun doin’ it. Lord, let your laughter ring forth. Be outrageous, ridicule the fraidy-cats, rejoice in all the oddities that freedom can produce.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Molly Ivins")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src139"
    }
  }, [_vm._v("Anything you can do in excess for the wrong reasons is exciting to me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Carrie Fisher")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src219"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _vm._v("My recipe for life is not being afraid of myself, afraid of what I think or of my opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Eartha Kitt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src24"
    }
  }, [_vm._v("No one can figure out your worth but you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Pearl Bailey")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src111"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('strong', [_vm._v("They say it is better to be poor and happy than rich and miserable, but how about a compromise like moderately rich and just moody?")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Princess Diana")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src232"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v("We are volcanoes. When we women offer our experience as our truth, as human truth, all the maps change. There are new mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ursula K. Le Guin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src420"
    }
  }, [_vm._v("Beware of monotony; it’s the mother of all the deadly sins.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Edith Wharton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src237"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("You must remember to never cease to act because you fear you may fail.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Lili’uokalani")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src82"
    }
  }, [_vm._v("Privacy and security are those things you give up when you show the world what makes you extraordinary.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Cho")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }), _vm._v("We are not interested in the possibilities of defeat; they do not exist.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Victoria")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src348"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _vm._v("Life is a "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("BANQUET")]), _vm._v(" and most poor suckers are "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("starving to death")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_b sans"
  }, [_vm._v("—"), _c('em', [_vm._v("Rosalind Russell")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src332"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }), _vm._v("I have very strong feelings about how you lead your life. You always look ahead, you never look back.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Ann Richards")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src125"
    }
  }, [_vm._v("The word’s out: I’m a woman, and I’m going to have trouble backing off on that. I am what I am.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Warren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src54"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('strong', [_vm._v("Don’t apologize for asking for what you deserve.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Mika Brzezinski")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src399"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('strong', [_vm._v("Well-behaved women seldom make history.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Laurel Thatcher Ulrich")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src68"
    }
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }), _vm._v("It’s because I’m a feminist that I can’t stand women limiting other women’s imaginations. It really makes me angry.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("A. S. Byatt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src47"
    }
  }, [_vm._v("Winning doesn’t always mean being first. Winning means you’re doing better than you’ve ever done before.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Bonnie Blair")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src83"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }), _vm._v("If we learn to open our hearts, anyone, including the people who drive us crazy, can be our teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Pema Chödrön")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src53"
    }
  }, [_vm._v("If you weigh well the strengths of our armies, you will see that in this battle we must conquer or die. This is a woman’s resolve. As for the men, they may live or be slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Boudicca")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src87"
    }
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }), _vm._v("I will "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("not")])]), _vm._v(" be triumphed over.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Cleopatra")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }), _vm._v("No woman can call herself free who does not control her own body.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Sanger")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src231"
    }
  }, [_vm._v("Many receive advice; only the wise profit from it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Harper Lee")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src342"
    }
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }), _vm._v("It takes a long time to get to be a diva. I mean, you gotta work at it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Diana Ross")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src190"
    }
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _vm._v("My mother taught me that when you stand in the truth and someone tells a lie about you, don’t fight it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Whitney Houston")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src358"
    }
  }, [_vm._v("There’s humor in everything. There’s gotta be humor in everything.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Amy Sedaris")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src209"
    }
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }), _vm._v("You take your life in your own hands, and what happens? A terrible thing: no one to blame.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Erica Jong")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("What you need is sustained outrage . . . there’s far too much unthinking respect given to authority.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Molly Ivins")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src310"
    }
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }), _c('strong', [_vm._v("Being a woman has only bothered me in climbing trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Frances Perkins")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src57"
    }
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }), _vm._v("There are always a few "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("who stand up")])]), _vm._v(" in times of communal madness and have the courage to say that "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("WHAT UNITES US IS GREATER THAN WHAT DIVIDES US")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Geraldine Brooks")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src167"
    }
  }, [_c('a', {
    attrs: {
      "id": "page53"
    }
  }), _vm._v("People are always looking for the single magic bullet that will totally change everything. There is no single magic bullet.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Temple Grandin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src220"
    }
  }, [_vm._v("I’m going to dance in all the galaxies.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Elisabeth Kübler-Ross")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src192"
    }
  }, [_c('a', {
    attrs: {
      "id": "page54"
    }
  }), _c('strong', [_vm._v("I want to be strong and empowered. I want to shock everybody.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Vanessa Hudgens")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src297"
    }
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }), _c('strong', [_vm._v("It’s not enough to be nice in life. You’ve got to have nerve.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Georgia O’Keeffe")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src127"
    }
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }), _vm._v("Nobody . . . took me seriously. They wondered why in the world I wanted to be a chemist when no women were doing that. The world was not waiting for me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Gertrude B. Elion")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src94"
    }
  }, [_vm._v("The best piece of advice that I remember probably on a daily basis is to accept everything about me that is different. That is what makes me special.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Misty Copeland")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src323"
    }
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }), _vm._v("I will feel "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("equality has arrived")])]), _vm._v(" when we can elect to office women who are as "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("INCOMPETENT AS SOME OF THE MEN")]), _vm._v(" who are already there.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Maureen Reagan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src89"
    }
  }, [_c('a', {
    attrs: {
      "id": "page58"
    }
  }), _vm._v("There’s no day that is the same as the day before. So you have to be energized; you have to be focused.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Hillary Clinton")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src377"
    }
  }, [_vm._v("I see no reason to keep silent about my enjoyment of the sound of my own voice as I work.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Muriel Spark")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src366"
    }
  }, [_c('a', {
    attrs: {
      "id": "page59"
    }
  }), _vm._v("A really strong woman accepts the war she went through and is ennobled by her scars.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Carly Simon")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src338"
    }
  }, [_vm._v("The world needs strong women. There are a lot of strong women you do not see who are guiding, helping, mothering strong men. They want to remain unseen. It’s kind of nice to be able to play a strong woman who is seen.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Ginger Rogers")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src228"
    }
  }, [_c('a', {
    attrs: {
      "id": "page60"
    }
  }), _vm._v("I am a strong woman with or without this other person, with or without this job, and with or without these tight pants.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Latifah")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src239"
    }
  }, [_vm._v("There is no sin punished more implacably by nature than the sin of resistance to change.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Anne Morrow Lindbergh")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src427"
    }
  }, [_c('a', {
    attrs: {
      "id": "page61"
    }
  }), _vm._v("I don’t like girls pretending to be stupid because it’s easier.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Amy Winehouse")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src174"
    }
  }, [_c('a', {
    attrs: {
      "id": "page62"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("Courage")])]), _vm._v(", sacrifice, determination, commitment, "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("toughness")])]), _vm._v(", heart, talent, "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("guts")])]), _vm._v(". That’s what little girls are made of; the heck with sugar and spice.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Bethany Hamilton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src340"
    }
  }, [_c('a', {
    attrs: {
      "id": "page63"
    }
  }), _vm._v("You gain strength, courage, and confidence by every experience in which you really stop to look fear in the face. You are able to say to yourself, “I lived through this horror. I can take the next thing that comes along.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Eleanor Roosevelt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src78"
    }
  }, [_vm._v("Remember our heritage is our power; we can know ourselves and our capacities by seeing that other women have been strong.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Judy Chicago")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src92"
    }
  }, [_c('a', {
    attrs: {
      "id": "page64"
    }
  }), _vm._v("You will do foolish things, but do them with enthusiasm.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Colette")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src155"
    }
  }, [_vm._v("Mile by mile, it’s a trial; yard by yard, it’s hard; but inch by inch, it’s a cinch.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Gabrielle Giffords")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src291"
    }
  }, [_c('a', {
    attrs: {
      "id": "page65"
    }
  }), _vm._v("Life shrinks or expands in proportion to one’s courage.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Anaïs Nin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("Though the sex to which I belong is considered weak, you will nevertheless find me a rock that bends to no wind.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_s"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Elizabeth I")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src58"
    }
  }, [_c('a', {
    attrs: {
      "id": "page66"
    }
  }), _c('strong', [_vm._v("First fight. "), _c('a', {
    attrs: {
      "id": "page67"
    }
  }), _vm._v("Then fiddle.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth31 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Gwendolyn Brooks")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src391"
    }
  }, [_c('a', {
    attrs: {
      "id": "page68"
    }
  }), _c('strong', [_vm._v("I always wondered why somebody doesn’t do something about that. Then I realized I was somebody.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Lily Tomlin")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src370"
    }
  }, [_c('a', {
    attrs: {
      "id": "page69"
    }
  }), _vm._v("I have stood on a mountain of no’s for one yes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("B. Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src69"
    }
  }, [_vm._v("Everyone shines, given the right lighting.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Susan Cain")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src145"
    }
  }, [_c('a', {
    attrs: {
      "id": "page70"
    }
  }), _vm._v("When you embrace your difference, your DNA, your look or heritage or religion or your unusual name, that’s when you start to shine.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Bethenny Frankel")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src398"
    }
  }, [_vm._v("The moment anyone tries to demean or degrade you in any way, you have to know how great you are. Nobody would bother to beat you down if you were not a threat.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Cicely Tyson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src159"
    }
  }, [_c('a', {
    attrs: {
      "id": "page71"
    }
  }), _vm._v("I am where I am because "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("I believe")])]), _vm._v(" in all possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Whoopi Goldberg")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src210"
    }
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Don’t compromise yourself. You are all you’ve got. There is no yesterday, no tomorrow; it’s all the same day.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Janis Joplin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src189"
    }
  }, [_c('a', {
    attrs: {
      "id": "page73"
    }
  }), _vm._v("You have to be taught to be second class; you’re not born that way.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lena Horne")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src42"
    }
  }, [_vm._v("At the end of the day, it’s not about equal rights, it’s about how we think. We have to reshape our own perception of how we view ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Beyoncé")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src245"
    }
  }, [_c('a', {
    attrs: {
      "id": "page74"
    }
  }), _vm._v("I have come to realize making yourself happy is most important. Never be ashamed of how you feel. You have the right to feel any emotion you want and do what makes you happy. That’s my life motto.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Demi Lovato")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src34"
    }
  }, [_vm._v("You grow up the day you have your first real laugh at yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ethel Barrymore")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src369"
    }
  }, [_c('a', {
    attrs: {
      "id": "page75"
    }
  }), _vm._v("Women have a special corner of their hearts for sins they have never committed.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Cornelia Otis Skinner")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src381"
    }
  }, [_vm._v("Without an open-minded mind, you can never be a great success.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Martha Stewart")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src131"
    }
  }, [_c('a', {
    attrs: {
      "id": "page76"
    }
  }), _c('strong', [_vm._v("My goal is to be accused of being strident.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Susan Faludi")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page77"
    }
  }), _vm._v("I never said I wanted a “happy” life but an interesting one. From separation and loss, I have learned a lot. I have become strong and resilient, as is the case of almost every human being exposed to life and the world. We don’t even know how strong we are until we are forced to bring that hidden strength forward.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Isabel Allende")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src372"
    }
  }, [_vm._v("I want to be around a really long time. I want to be a thorn in the side of everything as long as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Patti Smith")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src97"
    }
  }, [_c('a', {
    attrs: {
      "id": "page78"
    }
  }), _vm._v("There are lessons in everything. The bad, the good. Our job is to listen, and to continue to learn, so that maybe we get better at this. Maybe get better at life.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Laverne Cox")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("You don’t make progress by standing on the sidelines, whimpering and complaining. You make progress by implementing ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Shirley Chisholm")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src343"
    }
  }, [_c('a', {
    attrs: {
      "id": "page79"
    }
  }), _vm._v("I’m scared all the time. You have to have fear in order to have courage. I’m a courageous person because I’m a scared person.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Ronda Rousey")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src240"
    }
  }, [_vm._v("There’s no reason that young girls shouldn’t feel like they can’t smash people on the field. Nothing dirty. You want to keep it clean. You just want to play hard. Get your jersey dirty, shorts dirty, and just have fun out there.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Carli Lloyd")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page80"
    }
  }), _vm._v("It is there to be done, so I do it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Frances Perkins")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src329"
    }
  }, [_vm._v("You can waste your life drawing lines. Or you can live your life crossing them.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Shonda Rhimes")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src32"
    }
  }, [_c('a', {
    attrs: {
      "id": "page81"
    }
  }), _vm._v("If someone calls you "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("bossy")])]), _vm._v(" because "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("YOU DIDN’T LET THEM PUSH YOU")]), _vm._v(" around, so be it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Barra")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p sans"
  }, [_c('p', {
    staticClass: "quote_center2",
    attrs: {
      "id": "src71"
    }
  }, [_c('a', {
    attrs: {
      "id": "page82"
    }
  }), _vm._v("I think that if you shake the tree, you ought to be around when the fruit falls to pick it up.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Cassatt")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src288"
    }
  }, [_c('a', {
    attrs: {
      "id": "page83"
    }
  }), _vm._v("I have made my world and it is a much better world than I ever saw outside.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Louise Nevelson")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src426"
    }
  }, [_vm._v("We ask ourselves, “Who am I to be brilliant, gorgeous, talented, fabulous?” Actually, who are you not to be?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Marianne Williamson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src280"
    }
  }, [_c('a', {
    attrs: {
      "id": "page84"
    }
  }), _c('strong', [_vm._v("I get angry about things, then go on and work.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Toni Morrison")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page85"
    }
  }), _vm._v("The ultimate goal is to be an interesting, useful, wholesome person. If you’re successful on top of that, then you’re way ahead of everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Martha Stewart")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src225"
    }
  }, [_vm._v("You have to make mistakes to find out who you aren’t. You take the action, and the insight follows: You don’t think your way into becoming yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anne Lamott")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src50"
    }
  }, [_c('a', {
    attrs: {
      "id": "page86"
    }
  }), _vm._v("A person without curiosity may as well be dead.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Judy Blume")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("I don’t really want to become normal, average, standard. I want merely to gain in strength, in the courage to live out my life more fully, enjoy more, experience more. I want to develop even more original and more unconventional traits.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Anaïs Nin")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src184"
    }
  }, [_c('a', {
    attrs: {
      "id": "page87"
    }
  }), _vm._v("If you obey all the rules, you miss all the fun.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Katharine Hepburn")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src296"
    }
  }, [_c('a', {
    attrs: {
      "id": "page88"
    }
  }), _vm._v("You shall "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("know the truth")])]), _vm._v(", and the truth will "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("MAKE YOU ODD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Flannery O’Connor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page89"
    }
  }), _vm._v("No person is your friend who demands your silence, or denies your right to grow.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Alice Walker")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src38"
    }
  }, [_vm._v("I’ve gone from saint to whore and back to saint again, all in one lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ingrid Bergman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src150"
    }
  }, [_c('a', {
    attrs: {
      "id": "page90"
    }
  }), _c('strong', [_vm._v("Always be a first-rate version of yourself instead of a second-rate version of somebody else.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Judy Garland")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src437"
    }
  }, [_c('a', {
    attrs: {
      "id": "page91"
    }
  }), _c('strong', [_vm._v("All of my life I have always had the urge to do things better than anybody else.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Babe Didrikson Zaharias")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src259"
    }
  }, [_c('a', {
    attrs: {
      "id": "page92"
    }
  }), _vm._v("A lot of people are afraid to say what they want. That’s why they don’t get what they want.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Madonna")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src164"
    }
  }, [_vm._v("Courage is like a muscle. We strengthen it by use.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ruth Gordon")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src25"
    }
  }, [_c('a', {
    attrs: {
      "id": "page93"
    }
  }), _vm._v("My theory is, strong people don’t need strong leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ella Baker")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src282"
    }
  }, [_vm._v("It’s kind of rebellious to be yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Kate Moss")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src235"
    }
  }, [_c('a', {
    attrs: {
      "id": "page94"
    }
  }), _vm._v("What’s really terrible is to pretend that the second-rate is the first-rate. To pretend that you don’t need love when you do, or you like your work when you know quite well you’re capable of better.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Doris Lessing")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src387"
    }
  }, [_vm._v("You just do it. You force yourself to get up. You force yourself to put one foot before the other and, God damn it, you refuse to let it get to you. You fight. You cry. You curse. Then you go about the business of living. That’s how I’ve done it. There’s no other way.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Taylor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src112"
    }
  }, [_c('a', {
    attrs: {
      "id": "page95"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Darling, the legs aren’t so beautiful, I just know what to do with them.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Marlene Dietrich")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src31"
    }
  }, [_c('a', {
    attrs: {
      "id": "page96"
    }
  }), _vm._v("Women should try to "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("increase their size")])]), _vm._v(" rather than decrease it, because I believe the bigger we are, the more space we’ll take up, and the "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("MORE WE’LL HAVE TO BE RECKONED WITH")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Roseanne Barr")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src396"
    }
  }, [_c('a', {
    attrs: {
      "id": "page97"
    }
  }), _vm._v("My legacy is that I stayed on course . . . from the beginning to the end, because I believed in something inside of me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Tina Turner")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src256"
    }
  }, [_vm._v("To succeed in life, you need three things: a wishbone, a backbone, and a funny bone.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Reba McEntire")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src45"
    }
  }, [_c('a', {
    attrs: {
      "id": "page98"
    }
  }), _vm._v("My only ambition is to be true every moment I am living.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Juliette Binoche")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src272"
    }
  }, [_vm._v("You can’t control how other people see you or think of you. But you have to be comfortable with that.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Mirren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src334"
    }
  }, [_c('a', {
    attrs: {
      "id": "page99"
    }
  }), _vm._v("I’m crazy and I don’t pretend to be anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Rihanna")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src172"
    }
  }, [_c('a', {
    attrs: {
      "id": "page100"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("I’m an architect, not just a woman architect.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Zaha Hadid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src390"
    }
  }, [_c('a', {
    attrs: {
      "id": "page101"
    }
  }), _c('strong', [_vm._v("I don’t think there are any rude questions.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Thomas")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src312"
    }
  }, [_c('a', {
    attrs: {
      "id": "page102"
    }
  }), _vm._v("You can’t move mountains by whispering at them.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Pink")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src273"
    }
  }, [_vm._v("I feel myself becoming the fearless person I have dreamt of being. Have I arrived? No. But I’m constantly evolving and challenging myself to be unafraid to make mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Janelle Monáe")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src12"
    }
  }, [_vm._v("Cautious, careful people always casting about to preserve their reputations can never effect a reform.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Susan B. Anthony")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src375"
    }
  }, [_c('a', {
    attrs: {
      "id": "page103"
    }
  }), _vm._v("I urge you to be as impudent as you dare. "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("BE BOLD, BE BOLD, BE BOLD.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Susan Sontag")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src413"
    }
  }, [_c('a', {
    attrs: {
      "id": "page104"
    }
  }), _vm._v("Becoming yourself is really hard and confusing, and it’s a process. It’s often not cool to be the person who puts themselves out there.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Emma Watson")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src105"
    }
  }, [_vm._v("I never thought of myself as being in the avant-garde. I said what I had to say, as I was able to say it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Simone de Beauvoir")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src422"
    }
  }, [_vm._v("If you’re creating anything at all, it’s really dangerous to care about what people think.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Kristen Wiig")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page105"
    }
  }), _vm._v("I am interested in telling my particular truth as I have seen it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gwendolyn Brooks")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1"
  }, [_vm._v("I hated conventional art. I began to live.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Cassatt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src176"
    }
  }, [_vm._v("A woman who is willing to be herself and pursue her own potential runs not so much the risk of loneliness as the challenge of exposure to more interesting men—and people in general.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Lorraine Hansberry")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src275"
    }
  }, [_c('a', {
    attrs: {
      "id": "page106"
    }
  }), _vm._v("Your thorns are the best part of you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Marianne Moore")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src238"
    }
  }, [_c('a', {
    attrs: {
      "id": "page107"
    }
  }), _vm._v("To fly, we have to have resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Maya Lin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src317"
    }
  }, [_vm._v("We’re all strange inside. We learn how to disguise our differences as we grow up.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Annie Proulx")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src19"
    }
  }, [_vm._v("When things are really dismal, you can laugh, or you can cave in completely.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Atwood")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src364"
    }
  }, [_c('a', {
    attrs: {
      "id": "page108"
    }
  }), _vm._v("There are chapters in every life which are seldom read and certainly not aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Carol Shields")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src294"
    }
  }, [_vm._v("I ain’t afraid to love a man. I ain’t afraid to shoot him, either.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Annie Oakley")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src373"
    }
  }, [_c('a', {
    attrs: {
      "id": "page109"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Never let go of that fiery sadness called desire.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Patti Smith")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src424"
    }
  }, [_c('a', {
    attrs: {
      "id": "page110"
    }
  }), _vm._v("The success of every woman should be the inspiration to another. We should raise each other up. Make sure you’re very courageous: Be strong, be extremely kind, and above all be humble.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Serena Williams")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src227"
    }
  }, [_vm._v("I trust my instincts. I don’t distrust them. They haven’t led me astray. It’s when I’ve made up my mind to be efficient that is when I have gone wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Dorothea Lange")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src186"
    }
  }, [_vm._v("You’ve got to have something to eat and a little love in your life before you can hold still for any damn body’s sermon on how to behave.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Billie Holiday")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page111"
    }
  }), _vm._v("My life has been wonderful. I have done what I felt like. I was given courage and I was given adventure and that has carried me along. And then also a sense of humor and a little bit of common sense. It has been a very rich life.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Ingrid Bergman")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("I say if I’m beautiful. I say if I’m strong. You will not determine my story—I will.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Amy Schumer")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src224"
    }
  }, [_c('a', {
    attrs: {
      "id": "page112"
    }
  }), _vm._v("Some women choose to follow men, and some women choose to follow their dreams. If you’re wondering which way to go, remember that your career will never wake up and tell you that it doesn’t love you anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lady Gaga")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src382"
    }
  }, [_vm._v("People will say to me, “You’ve played so many strong women” and I’ll say, “Have you ever said to a man, ‘You’ve played so many strong men’?” No! The expectation is [men] are varied. Why can’t we have that expectation about women?")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Meryl Streep")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src102"
    }
  }, [_c('a', {
    attrs: {
      "id": "page113"
    }
  }), _vm._v("My passions were all gathered together like fingers that made a fist. Drive is considered aggression today; I knew it then as purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Bette Davis")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src345"
    }
  }, [_c('a', {
    attrs: {
      "id": "page114"
    }
  }), _vm._v("You will never truly know yourself, or the strength of your relationships, until both have been tested by adversity.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("J. K. Rowling")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src115"
    }
  }, [_vm._v("Difficult times have helped me to understand better than before how infinitely rich and beautiful life is in every way, and that so many things that one goes worrying about are of no importance whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Isak Dinesen")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src336"
    }
  }, [_vm._v("Show me a person who doesn’t like to laugh and I’ll show you a person with a toe tag.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Julia Roberts")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src63"
    }
  }, [_c('a', {
    attrs: {
      "id": "page115"
    }
  }), _vm._v("I used to be an optimist, but now I know that nothing is going to turn out as I expect.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Sandra Bullock")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src379"
    }
  }, [_vm._v("Considering how dangerous everything is, nothing is really very frightening.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gertrude Stein")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src113"
    }
  }, [_vm._v("I dwell in possibility.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Emily Dickinson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src353"
    }
  }, [_c('a', {
    attrs: {
      "id": "page116"
    }
  }), _c('strong', [_vm._v("When anger spreads through the breath, guard thy tongue from barking idly.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Sappho")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src124"
    }
  }, [_c('a', {
    attrs: {
      "id": "page117"
    }
  }), _vm._v("There is a great deal of unmapped country within us, which would have to be taken into account in an explanation of our gusts and storms.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("George Eliot")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("Trust your instincts . . . good relationships feel good. They feel right. They don’t hurt. They’re not painful.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Michelle Obama")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src187"
    }
  }, [_c('a', {
    attrs: {
      "id": "page118"
    }
  }), _vm._v("I will not have my life narrowed down. I will not bow down to somebody else’s whim or to someone else’s ignorance.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("bell hooks")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src162"
    }
  }, [_vm._v("[To William Butler Yeats:] Poets should never marry. The world should thank me for not marrying you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Maud Gonne")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src216"
    }
  }, [_c('a', {
    attrs: {
      "id": "page119"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("Reputation")])]), _vm._v(" is what others think about you. What’s far more important is "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("character")])]), _vm._v(", because that is what you think about yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Billie Jean King")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src136"
    }
  }, [_c('a', {
    attrs: {
      "id": "page120"
    }
  }), _c('strong', [_vm._v("Do your thing and don’t care if they like it.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Tina Fey")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src248"
    }
  }, [_c('a', {
    attrs: {
      "id": "page121"
    }
  }), _vm._v("Because I am a woman, I must make unusual efforts to succeed. If I fail, no one will say, “She doesn’t have what it takes.” They will say, “Women don’t have what it takes.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Clare Boothe Luce")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src389"
    }
  }, [_vm._v("One of the things being in politics has taught me is that men are not a reasoned or reasonable sex.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Thatcher")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b"
  }, [_c('a', {
    attrs: {
      "id": "page122"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Once you figure out what respect tastes like, it tastes better than attention. But you have to get there.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Pink")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src376"
    }
  }, [_c('a', {
    attrs: {
      "id": "page123"
    }
  }), _c('strong', [_vm._v("I do know one thing about me: I don’t measure myself by others’ expectations or let others define my worth.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Sonia Sotomayor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page124"
    }
  }), _vm._v("Oh, if I could but live another century and see the fruition of all the work for women! There is so much yet to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Susan B. Anthony")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src222"
    }
  }, [_vm._v("I wish people wouldn’t think of me as a saint—unless they agree with the definition of a saint that a saint’s a sinner who goes on trying.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Aung San Suu Kyi")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src56"
    }
  }, [_vm._v("When we are struck at without reason, we should strike back again very hard; I am sure we should—so hard as to teach the person who struck at us never to do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Charlotte Brontë")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src350"
    }
  }, [_c('a', {
    attrs: {
      "id": "page125"
    }
  }), _vm._v("You may impose "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("silence")])]), _vm._v(" upon me, but you can not prevent me from "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("thinking")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("George Sand")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src368"
    }
  }, [_c('a', {
    attrs: {
      "id": "page126"
    }
  }), _vm._v("The size of your dreams must always exceed your current capacity to achieve them. If your dreams do not scare you, they are not big enough.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ellen Johnson Sirleaf")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src134"
    }
  }, [_vm._v("Toughness doesn’t have to come in a pinstripe suit.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Dianne Feinstein")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src214"
    }
  }, [_vm._v("For someone with such an intense need to be liked, you’d think I would have figured out a way to be less of an asshole.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anna Kendrick")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src287"
    }
  }, [_c('a', {
    attrs: {
      "id": "page127"
    }
  }), _vm._v("I know what I want, and I know what needs to be done to make my performance better. So I do these little askings, about the lights and costumes. It’s not the diva speaking. It’s the artist who knows how it has to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anna Netrebko")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src278"
    }
  }, [_c('a', {
    attrs: {
      "id": "page128"
    }
  }), _vm._v("If you want to live your life through to the end, you have to live dangerously.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Jeanne Moreau")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src30"
    }
  }, [_vm._v("I am shocking, impertinent, and insolent. That’s how it is.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Brigitte Bardot")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src265"
    }
  }, [_c('a', {
    attrs: {
      "id": "page129"
    }
  }), _vm._v("Always be more than you appear and never appear to be more than you are.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Angela Merkel")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src421"
    }
  }, [_c('a', {
    attrs: {
      "id": "page130"
    }
  }), _vm._v("It’s your outlook on life that counts. If you take yourself lightly and don’t take yourself too seriously, pretty soon you can "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("find the humor")])]), _vm._v(" in our everyday lives. And sometimes it can be a lifesaver.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Betty White")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src434"
    }
  }, [_c('a', {
    attrs: {
      "id": "page131"
    }
  }), _vm._v("If there is a job that you feel passionate about, do what you can to pursue that job; if there is a purpose about which you are passionate, dedicate yourself to that purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Janet Yellen")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src27"
    }
  }, [_vm._v("It’s the good girls who keep the diaries; the bad girls never have the time.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Tallulah Bankhead")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src86"
    }
  }, [_vm._v("I never will have peace of mind. I’m not constructed that way. Some things in life can be horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Julie Christie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src304"
    }
  }, [_c('a', {
    attrs: {
      "id": "page132"
    }
  }), _vm._v("Follow your instincts and do not let other people’s opinion of you become your opinion of yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Jessica Parker")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("In societies where men are truly confident of their own worth, women are not merely tolerated but valued.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Aung San Suu Kyi")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src412"
    }
  }, [_vm._v("And we also know that when a woman stands up and speaks truth to power, that there will be attempts to put her down, and so I’m not going to be put down. I’m not going to go anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Maxine Waters")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src335"
    }
  }, [_c('a', {
    attrs: {
      "id": "page133"
    }
  }), _c('strong', [_vm._v("I was smart enough to go through any door that opened.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Joan Rivers")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src386"
    }
  }, [_c('a', {
    attrs: {
      "id": "page134"
    }
  }), _vm._v("The inference is that the men alone render useful service. But neither man nor woman eats these things until the woman has prepared it. The theory that the man who raises corn does a more important piece of work than the woman who makes it into bread is absurd.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ida M. Tarbell")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src246"
    }
  }, [_vm._v("That brain of mine is something more than merely mortal, as time will show.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ada Lovelace")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src322"
    }
  }, [_vm._v("Any time women come together with a collective intention, it’s a powerful thing. Whether it’s sitting down making a quilt, in a kitchen preparing a meal, in a club reading the same book, or around the table playing cards, or planning a birthday party, when women come together with a collective intention, magic happens.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Phylicia Rashad")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src132"
    }
  }, [_c('a', {
    attrs: {
      "id": "page135"
    }
  }), _vm._v("There are women who make things better, there are women who change things, there are women who make things happen, who make a difference. I want to be one of those women.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Vera Farmiga")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src67"
    }
  }, [_vm._v("I think sometimes women who are supposed to be strong are also written as mean and vindictive.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Yancy Butler")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src15"
    }
  }, [_vm._v("I only want people around me who can do the impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Arden")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src253"
    }
  }, [_c('a', {
    attrs: {
      "id": "page136"
    }
  }), _vm._v("You have to be willing to offend to make progress.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Claire McCaskill")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_center2 white"
  }, [_c('a', {
    attrs: {
      "id": "page137"
    }
  }), _vm._v("A surplus of effort could overcome a deficit of confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Sonia Sotomayor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src415"
    }
  }, [_c('a', {
    attrs: {
      "id": "page138"
    }
  }), _vm._v("I was always willing to take a great deal of the burden of getting along in life on my own shoulders, but I wasn’t willing to give myself a pat on the back. I was always looking to somebody else to give me that. That was all wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Raquel Welch")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src319"
    }
  }, [_vm._v("Life is about not knowing, having to change, taking the moment and making the best of it, without knowing what’s going to happen next.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Gilda Radner")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src298"
    }
  }, [_c('a', {
    attrs: {
      "id": "page139"
    }
  }), _vm._v("Each time we don’t say what we wanna say, we’re dying.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Yoko Ono")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src178"
    }
  }, [_vm._v("It is not the question, "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("what")]), _vm._v(" am I going to be when I grow up; you should ask the question, "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("who")]), _vm._v(" am I going to be when I grow up.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Goldie Hawn")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src200"
    }
  }, [_vm._v("At a very young age, I decided I was not going to follow women’s rules.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Joan Jett")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src423"
    }
  }, [_c('a', {
    attrs: {
      "id": "page140"
    }
  }), _vm._v("It’s one thing to live my own life and know that I’m okay. But there’s another thing I want to take on, and that is letting people know that they’re okay, too.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Samira Wiley")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src217"
    }
  }, [_vm._v("When I was younger, I was kind of fearless. I think it takes more courage to do things when you know more. I was completely naïve and I was like, “Why can’t I do anything I want to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Carole King")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src41"
    }
  }, [_vm._v("What’s the worst that can happen? If it doesn’t do well, I can put on my big girl panties, deal with it, and move on.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Halle Berry")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src429"
    }
  }, [_c('a', {
    attrs: {
      "id": "page141"
    }
  }), _c('strong', [_vm._v("I have bursts of being a lady, but it doesn’t last long.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Shelley Winters")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src137"
    }
  }, [_c('a', {
    attrs: {
      "id": "page142"
    }
  }), _vm._v("I was raised to sense what someone wanted me to be and be that kind of person. It took me a long time not to judge myself through someone else’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Sally Field")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src374"
    }
  }, [_vm._v("I’ve never backed down from a fight and I relish a good debate.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Olympia Snowe")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src116"
    }
  }, [_vm._v("No one is going to feel sorry for you, so you have to go out there and be fierce.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gabby Douglas")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('a', {
    attrs: {
      "id": "page143"
    }
  }), _vm._v("Don’t look at your feet to see if you are doing it right. "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Just dance")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Anne Lamott")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src215"
    }
  }, [_c('a', {
    attrs: {
      "id": "page144"
    }
  }), _c('strong', [_vm._v("What is sad for women of my generation is that they weren’t supposed to work if they had families. What were they going "), _c('a', {
    attrs: {
      "id": "page145"
    }
  }), _vm._v("to do when the children are grown—watch the raindrops coming down the window pane?")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Jackie Kennedy")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src188"
    }
  }, [_c('a', {
    attrs: {
      "id": "page146"
    }
  }), _vm._v("I am often drawn to what appear at first to be “dark” or “difficult” subjects, but which, upon further examination, are always and only reflections of the ways human beings attempt, however clumsily, badly, or well, to connect with others.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Marya Hornbacher")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src138"
    }
  }, [_vm._v("I have never tried to copy a man. I think it’s very important that a woman remembers that she is a woman and not a man. You’re a woman, so keep being a woman and show women and men that you are a woman. This sends the very important message that women are equal to men.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Vigdís Finnbogadóttir")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src243"
    }
  }, [_c('a', {
    attrs: {
      "id": "page147"
    }
  }), _vm._v("Do your best, one shot at a time, and then move on.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Nancy Lopez")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src43"
    }
  }, [_vm._v("A woman’s ability to make everyone in the room feel at home . . . should never be construed as weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Benazir Bhutto")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src324"
    }
  }, [_vm._v("There’s a big, wonderful world out there for you. It belongs to you. It’s exciting and stimulating and rewarding. Don’t cheat yourselves out of this promise.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Nancy Reagan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src321"
    }
  }, [_c('a', {
    attrs: {
      "id": "page148"
    }
  }), _vm._v("The question isn’t who’s going to "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("let me")])]), _vm._v("; it’s who’s going to "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("STOP ME")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ayn Rand")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src198"
    }
  }, [_c('a', {
    attrs: {
      "id": "page149"
    }
  }), _vm._v("Who am I? I’m my husband’s wife and I’m striving to be my own person.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Marian Javits")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src285"
    }
  }, [_vm._v("Always go with the choice that scares you the most, because that’s the one that is going to require the most from you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Caroline Myss")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src143"
    }
  }, [_vm._v("Normal is not something to aspire to, it’s something to get away from.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Jodie Foster")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src106"
    }
  }, [_c('a', {
    attrs: {
      "id": "page150"
    }
  }), _vm._v("That’s what being young is all about. You have the courage and the daring to think that you can make a difference. You’re not prone to measure your energies in time. You’re not likely to live by equations.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ruby Dee")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src360"
    }
  }, [_vm._v("I’m a multifaceted woman and person, like all women are—there’s no black and white. We have shades of grey in the middle. And even many more colors that other people don’t see.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Shakira")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src44"
    }
  }, [_c('a', {
    attrs: {
      "id": "page151"
    }
  }), _vm._v("Smiling doesn’t win you gold medals.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Simone Biles")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src271"
    }
  }, [_c('a', {
    attrs: {
      "id": "page152"
    }
  }), _vm._v("My advice to women in general: Even if you’re doing a nine-to-five job, treat yourself like a boss. Not arrogant, but be sure of what you want—and don’t allow people to run anything for you without your knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Nicki Minaj")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src254"
    }
  }, [_vm._v("I’m one of those women who’s not to be messed with. I’m very opinionated and boisterous at times. I’m also kind and humble. I know when to fold and when to hold, and that’s important. If my edge scares you, then you have a choice to remove yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("LisaRaye McCoy")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src166"
    }
  }, [_c('a', {
    attrs: {
      "id": "page153"
    }
  }), _vm._v("You are unique, and if that is not fulfilled, then something has been lost.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Martha Graham")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1"
  }, [_vm._v("You can’t be that kid standing at the top of the waterslide, overthinking it. You have to go down the chute.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Tina Fey")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src315"
    }
  }, [_vm._v("Smart women love smart men more than smart men love smart women.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Natalie Portman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src156"
    }
  }, [_c('a', {
    attrs: {
      "id": "page154"
    }
  }), _c('strong', [_vm._v("Stop wearing your wishbone where your backbone ought to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Gilbert")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src299"
    }
  }, [_c('a', {
    attrs: {
      "id": "page155"
    }
  }), _vm._v("Women are so strong and knowledgeable. You know, instead of competing with each other, I would love to complete each other. Take away that wall of competition and say, “Hey, let’s just all get together and help each other be brilliant.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Marie Osmond")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src144"
    }
  }, [_vm._v("I have a mouth and I’m not afraid to use it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Megan Fox")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src435"
    }
  }, [_c('a', {
    attrs: {
      "id": "page156"
    }
  }), _vm._v("In silence—and in self-defense—I figured things out in my own little way.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Loretta Young")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src65"
    }
  }, [_vm._v("When you come to a roadblock, take a detour.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Bush")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src320"
    }
  }, [_vm._v("The more our societies empower women, the more we receive in return.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Queen Rania of Jordan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src276"
    }
  }, [_c('a', {
    attrs: {
      "id": "page157"
    }
  }), _c('strong', [_vm._v("Take chances, make mistakes. That’s how you grow. Pain nourishes your courage. You have to fail in order to practice being brave.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Tyler Moore")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src128"
    }
  }, [_c('a', {
    attrs: {
      "id": "page158"
    }
  }), _vm._v("If you believe in your heart that you are right, you must "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("fight with all your might")])]), _vm._v(" to do it your way. Only dead fish swim with the stream all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Linda Ellerbee")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src257"
    }
  }, [_c('a', {
    attrs: {
      "id": "page159"
    }
  }), _vm._v("I think of life itself now as a wonderful play that I’ve written for myself, and so my purpose is to "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("HAVE THE UTMOST FUN PLAYING MY PART")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Shirley MacLaine")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src405"
    }
  }, [_c('a', {
    attrs: {
      "id": "page160"
    }
  }), _vm._v("Most of us have trouble juggling. The woman who says she doesn’t is someone whom I admire but have never met.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Walters")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src171"
    }
  }, [_vm._v("The reason why women effect so little and are so shallow is because their aims are low—marriage is the prize for which they strive; if foiled in that they rarely rise above disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Moore Grimké")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page161"
    }
  }), _vm._v("There has never been and never again will be a human being like you. There is nothing ordinary about you. If you feel ordinary, it is because you have chosen to hide the extraordinary parts of yourself from the world.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara De Angelis")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src292"
    }
  }, [_vm._v("Humor is the shock absorber of life; it helps us take the blows.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Peggy Noonan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src182"
    }
  }, [_c('a', {
    attrs: {
      "id": "page162"
    }
  }), _vm._v("I cannot and will not cut my conscience to fit this year’s fashions.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Lillian Hellman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page163"
    }
  }), _vm._v("Life is always a tightrope or a feather bed. Give me the tightrope.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Edith Wharton")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src293"
    }
  }, [_vm._v("This journey has always been about reaching your own other shore, no matter what it is, and that dream continues.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Diana Nyad")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src428"
    }
  }, [_vm._v("Do the one thing you think you cannot do. Fail at it. Try again. Do better the second time. The only people who never tumble are those who never mount the high wire. This is your moment. Own it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Oprah Winfrey")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src40"
    }
  }, [_c('a', {
    attrs: {
      "id": "page164"
    }
  }), _vm._v("Slow down? Rest? With all eternity before me?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Bernhardt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src141"
    }
  }, [_vm._v("Take your work seriously, but never yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Dame Margot Fonteyn")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src146"
    }
  }, [_vm._v("I sing to the realists, people who accept it like it is.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Aretha Franklin")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src196"
    }
  }, [_c('a', {
    attrs: {
      "id": "page165"
    }
  }), _vm._v("If I’m "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("too strong")])]), _vm._v(" for some people, "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("THAT’S THEIR PROBLEM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Glenda Jackson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src244"
    }
  }, [_c('a', {
    attrs: {
      "id": "page166"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_c('strong', [_vm._v("When I dare to be powerful, to use my strength in the service of my vision, then it becomes less and less important whether I am afraid.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Audre Lorde")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src39"
    }
  }, [_c('a', {
    attrs: {
      "id": "page167"
    }
  }), _vm._v("That disturbs people when they know they didn’t have the guts or integrity to stick to their dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sandra Bernhard")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src108"
    }
  }, [_vm._v("I always wanted to be normal. I tried really hard, but it’s like I try so hard and then people still say I’m offbeat. I’ve learned to accept that and take advantage of it as an actor.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Zooey Deschanel")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src173"
    }
  }, [_vm._v("You don’t have to like everybody, but you have to love everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Fannie Lou Hamer")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src197"
    }
  }, [_c('a', {
    attrs: {
      "id": "page168"
    }
  }), _c('strong', [_vm._v("Put yourself in the "), _c('a', {
    attrs: {
      "id": "page169"
    }
  }), _vm._v("path of lightning.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth31 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Valerie Jarrett")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src88"
    }
  }, [_c('a', {
    attrs: {
      "id": "page170"
    }
  }), _vm._v("Patience is a virtue, but impatience gets things done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Chelsea Clinton")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src123"
    }
  }, [_vm._v("Of all the nasty outcomes predicted for women’s liberation . . . none was more alarming . . . than the suggestion that women would eventually become just like men.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Ehrenreich")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src55"
    }
  }, [_c('a', {
    attrs: {
      "id": "page171"
    }
  }), _vm._v("Let the world know you as you are, not as you think you should be, because sooner or later, if you are posing, you will forget the pose and then where are you?")]), _vm._v(" "), _c('p', {
    staticClass: "auth sans"
  }, [_vm._v("—"), _c('em', [_vm._v("Fanny Brice")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src347"
    }
  }, [_c('a', {
    attrs: {
      "id": "page172"
    }
  }), _vm._v("Never underestimate the power of dreams and the influence of the human spirit. We are all the same in this notion: The potential for greatness lives within each of us.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Wilma Rudolph")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src308"
    }
  }, [_vm._v("I spent an awful lot of my life underestimating myself and, as a result, not exceeding my own expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Jane Pauley")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src133"
    }
  }, [_vm._v("God made men stronger but not necessarily more intelligent. He gave women intuition and femininity. And, used properly, that combination easily jumbles the brain of any man I’ve ever met.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Farrah Fawcett")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page173"
    }
  }), _vm._v("There are many persons ready to do what is right because in their hearts they know it is right. But they hesitate, waiting for the other fellow to make the first move—and he, in turn, waits for you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Marian Anderson")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src23"
    }
  }, [_vm._v("I’ve never had a humble opinion. If you’ve got an opinion, why be humble about it?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Joan Baez")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_center2 white"
  }, [_c('a', {
    attrs: {
      "id": "page174"
    }
  }), _vm._v("The thing women have yet to learn is nobody gives you power. You just take it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Roseanne Barr")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src77"
    }
  }, [_c('a', {
    attrs: {
      "id": "page175"
    }
  }), _vm._v("Some guy said to me: “Don’t you think you’re too old to sing rock ’n’ roll?” I said: “You better check with Mick Jagger.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Cher")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src289"
    }
  }, [_vm._v("The master class seldom lose a chance to insult a woman who has the ability for something besides service to his lordship.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Caroline Nichols Churchill")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src365"
    }
  }, [_c('a', {
    attrs: {
      "id": "page176"
    }
  }), _vm._v("Stop telling girls they can be anything they want when they grow up. . . . Because it would’ve never occurred to them that they couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Silverman")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("To feel valued, to know, even if only once in a while, that you can do a job well is an absolutely marvelous feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Walters")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src26"
    }
  }, [_vm._v("I’d rather regret the things I’ve done than regret the things I haven’t done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lucille Ball")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_center2",
    attrs: {
      "id": "src418"
    }
  }, [_c('a', {
    attrs: {
      "id": "page177"
    }
  }), _vm._v("Good girls go to heaven, bad girls go everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Mae West")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src395"
    }
  }, [_c('a', {
    attrs: {
      "id": "page178"
    }
  }), _vm._v("I really wanted to be nasty and mean and bad. It’s so much easier than being the good girl.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Robin Tunney")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src110"
    }
  }, [_vm._v("Keep your dreams alive. Understand to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gail Devers")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page179"
    }
  }), _vm._v("If we mean to have heroes, statesmen, and philosophers, we should have learned women.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Abigail Adams")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src170"
    }
  }, [_vm._v("Whatsoever it is morally right for a man to do, it is morally right for a woman to do.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Angelina Grimké")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src357"
    }
  }, [_c('a', {
    attrs: {
      "id": "page180"
    }
  }), _vm._v("I’ve always known I was gifted, which is not the easiest thing in the world for a person to know, because you’re not responsible for your gift, only for what you do with it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Hazel Scott")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src21"
    }
  }, [_vm._v("I naturally want to be provocative.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Iggy Azalea")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src249"
    }
  }, [_vm._v("I cannot tolerate fools—won’t have anything to do with them. I only want to associate with brilliant people.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ida Lupino")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page181"
    }
  }), _c('strong', [_vm._v("I want to live my life, not record it.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Jackie Kennedy")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page182"
    }
  }), _c('strong', [_vm._v("We still think of a powerful man as a born leader and a powerful woman as an anomaly.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Atwood")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page183"
    }
  }), _vm._v("My candle burns at both ends; it will not last the night; but ah, my foes, and oh, my friends—it gives a lovely light!")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Edna St. Vincent Millay")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src432"
    }
  }, [_vm._v("Lock up your libraries if you like; but there is no gate, no lock, no bolt that you can set upon the freedom of my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Virginia Woolf")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src303"
    }
  }, [_vm._v("The first thing I do in the morning is brush my teeth and sharpen my tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Dorothy Parker")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src268"
    }
  }, [_c('a', {
    attrs: {
      "id": "page184"
    }
  }), _vm._v("We work on macro issues and macaroni-and-cheese issues. When women are in the halls of power, our national debate reflects the needs and dreams of American families.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Mikulski")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("Life begets life. Energy creates energy. It is by spending oneself that one becomes rich.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Bernhardt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src22"
    }
  }, [_vm._v("I was a woman, a divorcee, a socialist, an agnostic . . . all possible sins together.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Michelle Bachelet")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src363"
    }
  }, [_c('a', {
    attrs: {
      "id": "page185"
    }
  }), _vm._v("My dreams were all my own; I accounted for them to nobody; they were my refuge when annoyed—"), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("my dearest pleasure")])]), _vm._v(" when free.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Shelley")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src409"
    }
  }, [_c('a', {
    attrs: {
      "id": "page186"
    }
  }), _vm._v("I’ve learned from experience that the greater part of our happiness or misery depends on our dispositions and not on our circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Martha Washington")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src344"
    }
  }, [_vm._v("I hope the fathers and mothers of little girls will look at them and say, “Yes, women can.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Dilma Rousseff")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src380"
    }
  }, [_vm._v("The art of life is not controlling what happens to us, but using what happens to us.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Steinem")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src90"
    }
  }, [_c('a', {
    attrs: {
      "id": "page187"
    }
  }), _vm._v("The worst thing that we can do as women is not stand up for each other, and this is something we can practice every day, no matter where we are and what we do—women sticking up for other women, choosing to protect and celebrate each other instead of competing or criticizing one another.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Amal Clooney")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src270"
    }
  }, [_c('a', {
    attrs: {
      "id": "page188"
    }
  }), _vm._v("To be a rebel is not to be a revolutionary. It is more often by a way of spinning one’s wheels deeper in sand.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Kate Millett")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src414"
    }
  }, [_vm._v("I do not make any apologies for my manner or personality. I come from a long line of very strong, black African-American women who neither bend nor bow. I haven’t had very good modeling in submission.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Faye Wattleton")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src430"
    }
  }, [_vm._v("Pain is real when you get other people to believe in it. If no one believes in it but you, your pain is madness or hysteria.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Naomi Wolf")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src8"
    }
  }, [_vm._v("T"), _c('a', {
    attrs: {
      "id": "page189"
    }
  }), _vm._v("here are some people who still feel threatened by strong women. "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("That’s their problem")])]), _vm._v(". "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("It’s not mine")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Allred")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src118"
    }
  }, [_c('a', {
    attrs: {
      "id": "page190"
    }
  }), _c('strong', [_vm._v("Don’t let them tame you.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Isadora Duncan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src406"
    }
  }, [_c('a', {
    attrs: {
      "id": "page191"
    }
  }), _vm._v("I’ve always been motivated more by negative comments than by positive ones. I know what I do well. Tell me what I don’t do well.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Abby Wambach")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src180"
    }
  }, [_vm._v("If you rest, you rust.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Hayes")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("Being a lady does not require silence.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Betty Ford")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src206"
    }
  }, [_c('a', {
    attrs: {
      "id": "page192"
    }
  }), _vm._v("When I was younger there was something in me. I had passion. I may not have known what I was going to do with that passion, but there was something—and I still feel it. It’s this little engine that roars inside of me and I just want to keep going and going.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Sheila Johnson")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src60"
    }
  }, [_vm._v("Need, yearn, and work—that is the kind of aggression that brings success, not acting dramatic.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Gurley Brown")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src1"
    }
  }, [_vm._v("I began wearing hats as a young lawyer because it helped me to establish my professional identity. Before that, whenever I was at a meeting, someone would ask me to get coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Bella Abzug")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src279"
    }
  }, [_c('a', {
    attrs: {
      "id": "page193"
    }
  }), _vm._v("Only she who attempts the absurd can achieve the impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Robin Morgan")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1"
  }, [_vm._v("Sometimes people try to destroy you, precisely because they recognize your power. Not because they don’t see it, but because they see it and they don’t want it to exist.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("bell hooks")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src378"
    }
  }, [_c('a', {
    attrs: {
      "id": "page194"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("We are, as a sex, infinitely superior to men, and if we were free and developed, healthy in body and mind, as we should be under "), _c('a', {
    attrs: {
      "id": "page195"
    }
  }), _vm._v("natural conditions, our motherhood would be our glory. That function gives women such wisdom and power as no male can possess.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Cady Stanton")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page196"
    }
  }), _vm._v("We need women who are at the head of a boardroom, like at the head of the White House, at the head of kind of major scientific enterprises so that little girls everywhere can then think, “You know what? I can do that, I want to do that, I will do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Chelsea Clinton")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("I am a mystery to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Angelina Grimké")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src130"
    }
  }, [_c('a', {
    attrs: {
      "id": "page197"
    }
  }), _vm._v("Wolves and women are relational by nature, inquiring, possessed of great endurance and strength. They are deeply intuitive, intensely concerned with their young, their mate, and their pack. Yet both have been hounded, harassed, and falsely imputed to be devouring and devious, overly aggressive, of less value than those who are their detractors.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Clarissa Pinkola Estés")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src36"
    }
  }, [_vm._v("Of any stopping place in life, it is good to ask whether it will be a good place from which to go on as well as a good place to remain.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Catherine Bateson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src263"
    }
  }, [_c('a', {
    attrs: {
      "id": "page198"
    }
  }), _vm._v("Always remember that you are absolutely unique. Just like everyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Mead")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("So whatever you want to do, just do it. . . . Making a damn fool of yourself is absolutely essential. And you will have a great time.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Steinem")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page199"
    }
  }), _c('strong', [_vm._v("Real integrity is doing the right thing, knowing that nobody’s going to know whether you did it or not.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Oprah Winfrey")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src300"
    }
  }, [_c('a', {
    attrs: {
      "id": "page200"
    }
  }), _vm._v("Women are in league with each other, a "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("secret conspiracy")]), _vm._v(" of hearts and pheromones.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Camille Paglia")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page201"
    }
  }), _vm._v("I’ve been described as a tough and noisy woman, a prize fighter, a man-hater—you name it. They call me Battling Bella, Mother Courage, and a Jewish mother with more complaints than Portnoy.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Bella Abzug")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src419"
    }
  }, [_vm._v("I myself have never been able to find out precisely what feminism is: I only know that people call me a feminist whenever I express sentiments that differentiate me from a doormat or a prostitute.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Rebecca West")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src169"
    }
  }, [_c('a', {
    attrs: {
      "id": "page202"
    }
  }), _vm._v("Women have very little idea of how much men hate them.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Germaine Greer")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1"
  }, [_vm._v("When you’re a girl, you have to be everything. You have to be dope at what you do, but you have to be super sweet, and you have to be sexy, and you have to be this, and you have to be that, and you have to be nice. . . . I can’t be all of those things at once. I’m a human being.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Nicki Minaj")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src218"
    }
  }, [_vm._v("It is very hard to be a female leader. While it is assumed that any man, no matter how tough, has a soft side . . . any female leader is assumed to be one-dimensional.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Billie Jean King")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page203"
    }
  }), _vm._v("A woman is like a tea bag—you can’t tell how strong she is until you put her in hot water.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Eleanor Roosevelt")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src211"
    }
  }, [_vm._v("It was a very cool thing to be a smart girl, as opposed to some other, different kind. And I think that made a great deal of difference to me growing up and in my life afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Elena Kagan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src191"
    }
  }, [_c('a', {
    attrs: {
      "id": "page204"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Every life has its actual blanks, which the ideal must fill up, or which else remain bare and profitless forever.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Julia Ward Howe")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src80"
    }
  }, [_c('a', {
    attrs: {
      "id": "page205"
    }
  }), _vm._v("I was gravely warned by some of my female acquaintances that no woman could expect to be regarded as a lady after she had written a book.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lydia Maria Child")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src393"
    }
  }, [_vm._v("If the first woman God ever made was strong enough to turn the world upside down all alone, these women together ought to be able to turn it back and get it right side up again.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sojourner Truth")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src302"
    }
  }, [_c('a', {
    attrs: {
      "id": "page206"
    }
  }), _vm._v("You have to make more noise than anybody else, you have to make yourself more obtrusive than anybody else, you have to fill all the papers more than anybody else, in fact you have to be there all the time and see that they do not snow you under, if you are really going to get your reform realized.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Emmeline Pankhurst")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src301"
    }
  }, [_c('a', {
    attrs: {
      "id": "page207"
    }
  }), _vm._v("It is our duty to make this world a "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("better place")]), _vm._v(" for women.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Christabel Pankhurst")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1"
  }, [_c('a', {
    attrs: {
      "id": "page208"
    }
  }), _c('strong', [_vm._v("Women have always been an equal part of the past. We just haven’t been a part of history.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Steinem")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src75"
    }
  }, [_c('a', {
    attrs: {
      "id": "page209"
    }
  }), _vm._v("Someday, somehow, I am going to do something useful, something for people. They are, most of them, so helpless, so hurt, and so unhappy.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Edith Cavell")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src361"
    }
  }, [_vm._v("A gentleman opposed to their enfranchisement once said to me, “Women have never produced anything of any value to the world.” I told him the chief product of the women had been the men, and left it to him to decide whether the product was of any value.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Anna Howard Shaw")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page210"
    }
  }), _vm._v("I knew well that the only way I could get that door open was to knock it down; because I knocked all of them down.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sadie Tanner Mossell Alexander")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src277"
    }
  }, [_vm._v("Depart from discretion when it interferes with duty.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Hannah More")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src433"
    }
  }, [_vm._v("I never wanted to feel I hadn’t worked hard enough.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Kristi Yamaguchi")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src148"
    }
  }, [_c('a', {
    attrs: {
      "id": "page211"
    }
  }), _vm._v("I tell you, in this world, being a little crazy helps to "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("keep you sane")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Zsa Zsa Gabor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote3_p pink_bg1 sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src274"
    }
  }, [_c('a', {
    attrs: {
      "id": "page212"
    }
  }), _c('strong', [_vm._v("This life is what you make it. No matter what, you’re going to mess up sometimes, it’s a universal truth. "), _c('a', {
    attrs: {
      "id": "page213"
    }
  }), _vm._v("But the good part is you get to decide how you’re going to mess it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Marilyn Monroe")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src199"
    }
  }, [_c('a', {
    attrs: {
      "id": "page214"
    }
  }), _vm._v("Never limit yourself because of others’ limited imagination; never limit others because of your own limited imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mae Jemison")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src98"
    }
  }, [_vm._v("Life is not easy for any of us. But what of that? We must have perseverance and, above all, confidence in ourselves. We must believe we are gifted for something and that this thing must be attained.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Marie Curie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p black sans"
  }, [_c('p', {
    staticClass: "quote_center2 white"
  }, [_c('a', {
    attrs: {
      "id": "page215"
    }
  }), _vm._v("I’m sick and tired of being sick and tired.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Fannie Lou Hamer")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1",
    attrs: {
      "id": "src326"
    }
  }, [_c('a', {
    attrs: {
      "id": "page216"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Channel")]), _vm._v(" your outrage. . . . Do that which you are able to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Kathy Reichs")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src120"
    }
  }, [_c('a', {
    attrs: {
      "id": "page217"
    }
  }), _vm._v("The argument between wives and whores is an old one; each one thinking that whatever she is, at least she is not the other.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Andrea Dworkin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src122"
    }
  }, [_vm._v("Whoever said anybody has a right to give up?")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Marian Wright Edelman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src100"
    }
  }, [_c('a', {
    attrs: {
      "id": "page218"
    }
  }), _vm._v("“God’s plan” is often a front for men’s plans and a cover for inadequacy, ignorance, and evil.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Daly")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src404"
    }
  }, [_vm._v("I had to make my own living and my own opportunity. But I made it! Don’t sit down and wait for the opportunities to come. Get up and make them.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Madame C. J. Walker")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src247"
    }
  }, [_c('a', {
    attrs: {
      "id": "page219"
    }
  }), _vm._v("Right is right, even if no one else does it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Juliette Gordon Low")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src251"
    }
  }, [_vm._v("Nine-tenths of our suffering is caused by others not thinking so much of us as we think they ought.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Lyon")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src161"
    }
  }, [_c('a', {
    attrs: {
      "id": "page220"
    }
  }), _vm._v("The history of progress is written in the blood of men and women who have dared to espouse an unpopular cause, as, for instance, the black man’s right to his body, or woman’s right to her soul.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Emma Goldman")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src416"
    }
  }, [_vm._v("The appetite grows for what it feeds on.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Ida B. Wells")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src177"
    }
  }, [_c('a', {
    attrs: {
      "id": "page221"
    }
  }), _vm._v("I am a woman who enjoys herself very much; sometimes I lose, sometimes I win.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Mata Hari")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src201"
    }
  }, [_vm._v("One life is all we have and we live it as we believe in living it. But to sacrifice what you are and to live without belief, that is a fate more terrible than dying.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Joan of Arc")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src91"
    }
  }, [_c('a', {
    attrs: {
      "id": "page222"
    }
  }), _vm._v("I refused to take no for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Bessie Coleman")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src236"
    }
  }, [_vm._v("My experience in childhood and adolescence of the subordinate role played by the female in a society run entirely by men had convinced me that I was not cut out to be a wife.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Rita Levi-Montalcini")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page223"
    }
  }), _c('strong', [_vm._v("There’s something contagious about demanding freedom.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Robin Morgan")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src226"
    }
  }, [_c('a', {
    attrs: {
      "id": "page224"
    }
  }), _vm._v("No one can take advantage of you without your permission.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Ann Landers")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src121"
    }
  }, [_c('a', {
    attrs: {
      "id": "page225"
    }
  }), _vm._v("I want to do it because I want to do it. Women must try to do things as men have tried. When they fail, their failure must be but a challenge to others.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Amelia Earhart")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src408"
    }
  }, [_vm._v("You can be the lead in your own life.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Kerry Washington")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src355"
    }
  }, [_c('a', {
    attrs: {
      "id": "page226"
    }
  }), _vm._v("The question was asked, “How can you be a mother and a congresswoman?” I said, “I have a brain, I have a uterus, and they both work.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Patricia Schroeder")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src309"
    }
  }, [_vm._v("Anybody who’s ever dealt with me knows not to mess with me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Nancy Pelosi")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src388"
    }
  }, [_c('a', {
    attrs: {
      "id": "page227"
    }
  }), _c('strong', [_vm._v("I make the most of all that comes and the least of all that goes.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Sara Teasdale")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center",
    attrs: {
      "id": "src230"
    }
  }, [_c('a', {
    attrs: {
      "id": "page228"
    }
  }), _vm._v("Humility is no substitute for a good personality.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Fran Lebowitz")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src233"
    }
  }, [_c('a', {
    attrs: {
      "id": "page229"
    }
  }), _vm._v("You have trust in what you think. If you splinter yourself and try to please everyone, you can’t.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Annie Leibovitz")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src400"
    }
  }, [_vm._v("You are what you are when nobody is looking.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Abigail Van Buren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src158"
    }
  }, [_c('a', {
    attrs: {
      "id": "page230"
    }
  }), _c('strong', [_vm._v("People ask me sometimes, “When will there be enough women on the court?” And my answer is: “When there are nine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Ruth Bader Ginsburg")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src147"
    }
  }, [_c('a', {
    attrs: {
      "id": "page231"
    }
  }), _vm._v("For me, it seems to help me take the pressure off if I don’t pay attention to what other people are telling me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Missy Franklin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src70"
    }
  }, [_vm._v("A leader takes people where they want to go A great leader takes people where they don’t necessarily want to go, but ought to be.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Rosalynn Carter")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white"
  }, [_c('a', {
    attrs: {
      "id": "page232"
    }
  }), _vm._v("Once we give up searching for approval, we often find it easier to earn respect.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Steinem")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src260"
    }
  }, [_c('a', {
    attrs: {
      "id": "page233"
    }
  }), _vm._v("We must trust our own thinking. Trust where we’re going. And get the job done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Wilma Mankiller")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src152"
    }
  }, [_c('a', {
    attrs: {
      "id": "page234"
    }
  }), _vm._v("I embrace the label of bad feminist because I am human. I am messy. I’m not trying to be an example. I am not trying to be perfect. I am not trying to say I have all the answers. I am not trying to say I’m right. I am just trying—trying to support what I believe in, trying to do some good in this world, trying to make some noise with my writing while also being myself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Roxane Gay")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b1"
  }, [_c('a', {
    attrs: {
      "id": "page235"
    }
  }), _c('strong', [_vm._v("If you just set out to be liked, you would be prepared to compromise on anything at any time, and you would achieve nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b1"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Thatcher")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src431"
    }
  }, [_c('a', {
    attrs: {
      "id": "page236"
    }
  }), _vm._v("I shall not change my course because those who assume to be better than I desire it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Victoria Woodhull")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src207"
    }
  }, [_vm._v("I’ve been reckless, but I’m not a rebel without a cause.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Angelina Jolie")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src252"
    }
  }, [_vm._v("Success breeds confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Beryl Markham")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('a', {
    attrs: {
      "id": "page237"
    }
  }), _vm._v("If you look at what you have in life, you’ll always have more. If you look at what you don’t have in life, you’ll never have enough.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Oprah Winfrey")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src74"
    }
  }, [_c('a', {
    attrs: {
      "id": "page238"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("There are whole precincts of voters in this country whose united intelligence does not equal that of one representative American woman.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Carrie Chapman Catt")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src49"
    }
  }, [_c('a', {
    attrs: {
      "id": "page239"
    }
  }), _c('strong', [_vm._v("It will not do to say that it is out of woman’s sphere to assist in making laws, for if that were so, then it should be also out of her sphere to submit to them.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Amelia Bloomer")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('a', {
    attrs: {
      "id": "page240"
    }
  }), _vm._v("The most difficult thing is to act; the rest is merely tenacity.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Amelia Earhart")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src325"
    }
  }, [_c('a', {
    attrs: {
      "id": "page241"
    }
  }), _vm._v("One of the secrets to staying young is to always do things you don’t know how to do, to keep learning.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ruth Reichl")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src339"
    }
  }, [_vm._v("Be first and be lonely.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Ginni Rometty")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page242"
    }
  }), _vm._v("I found out along the way that they like you a little imperfect.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lena Horne")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src255"
    }
  }, [_vm._v("You can best fight any existing evil from the inside.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Hattie McDaniel")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src351"
    }
  }, [_c('a', {
    attrs: {
      "id": "page243"
    }
  }), _c('strong', [_vm._v("As a man gets more successful, he is "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("better liked")]), _vm._v(" by men and women, and as a woman gets more successful, she is "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("less liked")]), _vm._v(" by men and women.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Sheryl Sandberg")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_center2",
    attrs: {
      "id": "src51"
    }
  }, [_c('a', {
    attrs: {
      "id": "page244"
    }
  }), _vm._v("Never having failed, I could not picture what failure meant.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Nellie Bly")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_center2 white",
    attrs: {
      "id": "src103"
    }
  }, [_c('a', {
    attrs: {
      "id": "page245"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Don’t call me a saint. I don’t want to be dismissed that easily.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_c('em', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—Dorothy Day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src349"
    }
  }, [_c('a', {
    attrs: {
      "id": "page246"
    }
  }), _vm._v("Everything I do is for my people.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Sacagawea")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src286"
    }
  }, [_vm._v("I know I can do more good by being vocal than by staying quiet. I’d have a whole lot more money if I lied, but I wouldn’t enjoy spending it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Martina Navratilova")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("If you think taking care of yourself is selfish, change your mind. If you don’t, you’re simply ducking your responsibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Ann Richards")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page247"
    }
  }), _c('strong', [_vm._v("When you can’t find someone to follow, you have to find a way to lead by example.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Roxane Gay")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src223"
    }
  }, [_c('a', {
    attrs: {
      "id": "page248"
    }
  }), _c('strong', [_vm._v("There is no social-change fairy. There is only change made by the hands of individuals.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Winona LaDuke")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src181"
    }
  }, [_c('a', {
    attrs: {
      "id": "page249"
    }
  }), _vm._v("Greatness is not measured by what a man or woman accomplishes, but by the opposition he or she has overcome to reach his goals.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Dorothy Height")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("This world taught woman nothing skillful and then said her work was valueless. It permitted her no opinions and said she did not know how to think. It forbade her to speak in public and said the sex had no orators.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Carrie Chapman Catt")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page250"
    }
  }), _vm._v("Of course I am "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("not worried about intimidating men")])]), _vm._v(". The type of man who will be intimidated by me is exactly the type of man I have no interest in.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Chimamanda Ngozi Adichie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src52"
    }
  }, [_c('a', {
    attrs: {
      "id": "page251"
    }
  }), _vm._v("You don’t choose the times you live in, but you do choose who you want to be. And you do choose how you think.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Grace Lee Boggs")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src101"
    }
  }, [_vm._v("You have to act as if it were possible to radically transform the world. And you have to do it all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Angela Davis")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page252"
    }
  }), _vm._v("Idealists foolish enough to throw caution to the winds have advanced mankind and have enriched the world.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Emma Goldman")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src242"
    }
  }, [_vm._v("Doubt is a killer. You just have to know who you are and what you stand for.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Jennifer Lopez")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_center1 white"
  }, [_c('a', {
    attrs: {
      "id": "page253"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("We are the women men warned us about.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Robin Morgan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src221"
    }
  }, [_c('a', {
    attrs: {
      "id": "page254"
    }
  }), _vm._v("I’m an old woman. I have gray hair, many wrinkles, and arthritis in both hands. And "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("I CELEBRATE MY FREEDOM")]), _vm._v(" from bureaucratic restraints that once held me.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Maggie Kuhn")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src267"
    }
  }, [_c('a', {
    attrs: {
      "id": "page255"
    }
  }), _vm._v("Cherish what makes you unique, ’cause you’re really a yawn if it goes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Bette Midler")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src307"
    }
  }, [_vm._v("I always feel the movement is a sort of mosaic. Each of us puts in one little stone and then you get a great mosaic at the end.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Alice Paul")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b"
  }, [_c('a', {
    attrs: {
      "id": "page256"
    }
  }), _c('strong', [_vm._v("Take criticism seriously, but not personally. If there is truth or merit in the criticism, try to learn from it. Otherwise, let it roll right off you.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Hillary Clinton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src337"
    }
  }, [_c('a', {
    attrs: {
      "id": "page257"
    }
  }), _vm._v("Feel empowered. And if you start to do it, if you start to feel your voice heard, you will never go back.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Robinson")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("The torment that so many young women know, bound hand and foot by love and motherhood, without having forgotten their former dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Simone de Beauvoir")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src284"
    }
  }, [_c('a', {
    attrs: {
      "id": "page258"
    }
  }), _vm._v("Whenever I don’t know whether to fight or not, I fight.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Emily Murphy")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("It takes a great deal of courage to stand up to your enemies, but a great deal more to stand up to your friends.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("J. K. Rowling")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src241"
    }
  }, [_c('a', {
    attrs: {
      "id": "page259"
    }
  }), _vm._v("The people I’m furious with are the women’s liberationists. They keep getting up on soapboxes and proclaiming women are brighter than men. That’s true, but it should be kept quiet or it ruins the whole racket.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anita Loos")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src64"
    }
  }, [_vm._v("I’m always perpetually out of my comfort zone.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Tory Burch")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white"
  }, [_c('a', {
    attrs: {
      "id": "page260"
    }
  }), _vm._v("It irritates me to be told how things always have been done. . . .")])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src35"
    }
  }, [_c('a', {
    attrs: {
      "id": "page261"
    }
  }), _vm._v("I defy the tyranny of precedent. I cannot afford the luxury of a closed mind.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Clara Barton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src281"
    }
  }, [_c('a', {
    attrs: {
      "id": "page262"
    }
  }), _vm._v("Women must learn to find self-worth within themselves, not through others. It is important to carve out a place just for you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Georgette Mosbacher")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src385"
    }
  }, [_vm._v("Define success on your own terms, achieve it by your own rules, and build a life you’re proud to live.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anne Sweeney")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src48"
    }
  }, [_c('a', {
    attrs: {
      "id": "page263"
    }
  }), _vm._v("Don’t be intimidated by what you don’t know. That can be your greatest strength and ensure that you do things differently from everyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Sara Blakely")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src157"
    }
  }, [_vm._v("There is no female mind. The brain is not an organ of sex. Might as well speak of a female liver.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Charlotte Perkins Gilman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page264"
    }
  }), _vm._v("The girls who were unanimously considered beautiful often rested on their beauty alone. I felt I had to do things.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Diane von Fürstenberg")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src163"
    }
  }, [_vm._v("What you do makes a difference, and you have to decide what kind of difference you want to make.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Jane Goodall")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page265"
    }
  }), _c('strong', [_vm._v("I would have girls regard themselves not as adjectives, but as nouns.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Cady Stanton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1"
  }, [_c('a', {
    attrs: {
      "id": "page266"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Your inability to see yourself clearly is what’s keeping you alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Silverman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1"
  }, [_c('a', {
    attrs: {
      "id": "page267"
    }
  }), _vm._v("I’m no longer accepting the things I cannot change. I’m changing the things I cannot accept.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Angela Davis")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src262"
    }
  }, [_c('a', {
    attrs: {
      "id": "page268"
    }
  }), _vm._v("I always did something I was a little not ready to do. I think that’s how you grow. When there’s that moment of “Wow, I’m not really sure I can do this,” and you push through those moments, that’s when you have a breakthrough.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Marissa Mayer")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src193"
    }
  }, [_vm._v("If you haven’t forgiven yourself something, how can you forgive others?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Dolores Huerta")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page269"
    }
  }), _vm._v("Stand before the people you fear and speak your mind—even if your voice shakes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Maggie Kuhn")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src46"
    }
  }, [_vm._v("It is not easy to be a pioneer—but oh, it is fascinating! I would not trade one moment, even the worst moment, for all the riches in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Blackwell")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src341"
    }
  }, [_c('a', {
    attrs: {
      "id": "page270"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("Girls are not socialized to toot their own horns. But bosses aren’t mind readers. "), _c('a', {
    attrs: {
      "id": "page271"
    }
  }), _vm._v("Speak up and let people know what you’ve done and what you want.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Irene Rosenfeld")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page272"
    }
  }), _vm._v("I have frequently been questioned, especially by women, of how I could reconcile family life with a scientific career. Well, it has not been easy.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Marie Curie")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src203"
    }
  }, [_vm._v("Trust your instincts. Lots of people will give you advice, and depending on how well they know you, the advice might be valid or not so valid. But at the end of the day, you know yourself best and you know what works best for you. . . . Don’t doubt yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Abigail Johnson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page273"
    }
  }), _c('strong', [_vm._v("If you don’t risk anything, you risk even more.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Erica Jong")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src261"
    }
  }, [_c('a', {
    attrs: {
      "id": "page274"
    }
  }), _vm._v("No one provokes me with impunity.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_c('em', [_vm._v("—Mary, Queen of Scots")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src290"
    }
  }, [_c('a', {
    attrs: {
      "id": "page275"
    }
  }), _vm._v("Rather, ten times, die in the surf, heralding the way to a new world, than stand idly on the shore.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Florence Nightingale")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("My mother told me to be a lady. And for her, that meant be your own person, be independent.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ruth Bader Ginsburg")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page276"
    }
  }), _vm._v("Make the most of yourself by fanning the tiny, inner sparks of possibility into flames of achievement.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Golda Meir")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src59"
    }
  }, [_vm._v("What’s the greater risk? Letting go of what people think, or letting go of how I feel, what I believe, and who I am?")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Brené Brown")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p pink_bg"
  }, [_c('p', {
    staticClass: "quote_center white",
    attrs: {
      "id": "src313"
    }
  }, [_c('a', {
    attrs: {
      "id": "page277"
    }
  }), _vm._v("Wear your heart on your skin in this life.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center white"
  }, [_vm._v("—"), _c('em', [_vm._v("Sylvia Plath")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page278"
    }
  }), _vm._v("One must be frank to be relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Corazon Aquino")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src73"
    }
  }, [_c('a', {
    attrs: {
      "id": "page279"
    }
  }), _vm._v("One does not always do the best there is. One does the best one can.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Catherine the Great")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src29"
    }
  }, [_vm._v("There will not be a magic day when we wake up and it’s now okay to express ourselves publicly. We make that day by doing things publicly until it’s simply the way things are.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Tammy Baldwin")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src79"
    }
  }, [_c('a', {
    attrs: {
      "id": "page280"
    }
  }), _vm._v("Drama is very important in life: You have to come on with a bang. "), _c('a', {
    attrs: {
      "id": "page281"
    }
  }), _vm._v("You never want to go out with a whimper.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_vm._v("—"), _c('em', [_vm._v("Julia Child")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src392"
    }
  }, [_c('a', {
    attrs: {
      "id": "page282"
    }
  }), _c('strong', [_vm._v("I can’t be a rose "), _c('a', {
    attrs: {
      "id": "page283"
    }
  }), _vm._v("in any man’s lapel.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b white"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Trudeau")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page284"
    }
  }), _vm._v("You cannot divide creative juices from human juices. And as long as juicy women are equated with bad women, we will err on the side of being bad.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Erica Jong")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src165"
    }
  }, [_vm._v("A mistake is simply another way of doing things.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Katharine Graham")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page285"
    }
  }), _vm._v("I want to make sure we use all our talent, not just 25 percent.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mae Jemison")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1"
  }, [_vm._v("I am glad that I paid so little attention to good advice; had I abided by it I might have been saved from some of my most valuable mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Edna St. Vincent Millay")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src371"
    }
  }, [_c('a', {
    attrs: {
      "id": "page286"
    }
  }), _vm._v("The right way is not always the popular and easy way. Standing for right when it is unpopular is a true test of moral character.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Margaret Chase Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src16"
    }
  }, [_vm._v("I’m not worried. I’m in control.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Macapagal Arroyo")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page287"
    }
  }), _c('strong', [_vm._v("There is a special place in hell for women who do not help other women.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Madeleine K. Albright")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src76"
    }
  }, [_c('a', {
    attrs: {
      "id": "page288"
    }
  }), _vm._v("In order to be irreplaceable, one must always "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("be different")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Coco Chanel")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src229"
    }
  }, [_c('a', {
    attrs: {
      "id": "page289"
    }
  }), _vm._v("I didn’t get there by wishing for it or hoping for it, but by working for it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Estée Lauder")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src95"
    }
  }, [_vm._v("The difference between successful people and others is how long they spend time feeling sorry for themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Barbara Corcoran")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src250"
    }
  }, [_c('a', {
    attrs: {
      "id": "page290"
    }
  }), _vm._v("Being human means throwing your whole life on the scales of destiny when need be, all the while rejoicing in every sunny day and every beautiful cloud.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Rosa Luxemburg")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("Tremendous amounts of talent are lost to our society just because that talent wears a skirt.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Shirley Chisholm")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page291"
    }
  }), _vm._v("We teach girls to shrink themselves, to make themselves smaller. We say to girls, you can have ambition, but not too much. You should aim to be successful, but not too successful. Otherwise, you would threaten the man.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Chimamanda Ngozi Adichie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src168"
    }
  }, [_c('a', {
    attrs: {
      "id": "page292"
    }
  }), _vm._v("Often we women are risk-averse. I needed the push. Now, more than ever, young women need more seasoned women to provide that encouragement, to take a risk, to go for it. Once a glass ceiling is broken, it stays broken.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Jennifer Granholm")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src327"
    }
  }, [_vm._v("I’m not fancy. I’m what I appear to be.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Janet Reno")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b"
  }, [_c('a', {
    attrs: {
      "id": "page293"
    }
  }), _c('strong', [_vm._v("I learned to always take on things I’d never done before. Growth and comfort "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("do not coexist.")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Ginni Rometty")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page294"
    }
  }), _c('strong', [_vm._v("In order to be irreplaceable, one must always be different.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Coco Chanel")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src333"
    }
  }, [_c('a', {
    attrs: {
      "id": "page295"
    }
  }), _vm._v("I’ve spent my whole life not talking to people, and I don’t see why I should start now.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Sally Ride")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src93"
    }
  }, [_vm._v("The only way to escape fear is to trample it beneath your feet.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Nadia Com˘aneci")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src129"
    }
  }, [_c('a', {
    attrs: {
      "id": "page296"
    }
  }), _vm._v("Above all, be the heroine of your life, not the victim.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Nora Ephron")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src18"
    }
  }, [_vm._v("I married beneath me—all women do.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Nancy Astor")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src135"
    }
  }, [_c('a', {
    attrs: {
      "id": "page297"
    }
  }), _vm._v("Some leaders are "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("born women")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Geraldine Ferraro")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page298"
    }
  }), _c('strong', [_vm._v("Nasty women are tough. Nasty women are smart. And nasty women vote.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Elizabeth Warren")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page299"
    }
  }), _vm._v("The single best thing about honesty is that it requires no follow-up.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Rachel Maddow")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src85"
    }
  }, [_vm._v("I have sometimes been wildly, despairingly, acutely miserable, racked with sorrow, but through it all I still know quite certainly that just to be alive is a grand thing.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Agatha Christie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page300"
    }
  }), _vm._v("The sight of women talking together has always made men uneasy; nowadays it means rank subversion.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Germaine Greer")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("No one can make you feel inferior without your consent.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Eleanor Roosevelt")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1"
  }, [_c('a', {
    attrs: {
      "id": "page301"
    }
  }), _vm._v("A sex symbol becomes a thing. "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("I just hate to be a thing")])]), _vm._v(". But if I’m going to be a symbol of something, I’d rather have it be sex than some other things they’ve got symbols of.")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center1"
  }, [_vm._v("—"), _c('em', [_vm._v("Marilyn Monroe")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page302"
    }
  }), _c('strong', [_vm._v("Women have been called queens for a long time, but the kingdom given them isn’t worth ruling.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Louisa May Alcott")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src354"
    }
  }, [_c('a', {
    attrs: {
      "id": "page303"
    }
  }), _vm._v("Whatever you want in life, other people are going to want it, too. Believe in yourself enough to accept the idea that you have an equal right to it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Diane Sawyer")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src62"
    }
  }, [_vm._v("I love people. I love my family, my children . . . but inside myself is a place where I live all alone and that’s where you renew your springs that never dry up.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Pearl Buck")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page304"
    }
  }), _vm._v("Well, knowledge is a fine thing, and mother Eve thought so; but she smarted so severely for hers, that most of her daughters have been afraid of it since.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Abigail Adams")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2"
  }, [_vm._v("That would be a good thing for them to cut on my tombstone: “Wherever she went, including here, it was against her better judgment.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Dorothy Parker")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src331"
    }
  }, [_c('a', {
    attrs: {
      "id": "page305"
    }
  }), _vm._v("The connections between and among women are the most feared, the most problematic, and the most potentially transforming force on the planet.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Adrienne Rich")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src328"
    }
  }, [_vm._v("Working hard becomes a habit, a serious kind of fun.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Lou Retton")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text"
  }, [_c('a', {
    attrs: {
      "id": "page306"
    }
  }), _vm._v("And the day came when the risk to remain tight in a bud was more painful than the risk it took to blossom.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anaïs Nin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src417"
    }
  }, [_vm._v("I’ve always been an angel. Sometimes I transform into a witch only because the filmmaking demands it.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Lina Wertmüller")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center1",
    attrs: {
      "id": "src362"
    }
  }, [_c('a', {
    attrs: {
      "id": "page307"
    }
  }), _vm._v("When men reach their sixties and retire, they go to pieces. "), _c('span', {
    staticClass: "pink f_small"
  }, [_vm._v("WOMEN GO RIGHT ON COOKING")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Gail Sheehy")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p black sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src425"
    }
  }, [_c('a', {
    attrs: {
      "id": "page308"
    }
  }), _vm._v("Some people say I have attitude—maybe I do. But I think you have to. You have to believe "), _c('a', {
    attrs: {
      "id": "page309"
    }
  }), _vm._v("in yourself when no one else does. That makes you a winner right there.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Venus Williams")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page310"
    }
  }), _vm._v("You can’t please everyone and you can’t make everyone like you.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Katie Couric")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src316"
    }
  }, [_vm._v("I totally and completely admit, with no qualms at all, my egomania, my selfishness, coupled with a really magnificent voice.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Leontyne Price")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text2"
  }, [_c('a', {
    attrs: {
      "id": "page311"
    }
  }), _vm._v("It fills me with a weird rage to wear shoes that make me not able to walk easily or run if I had to. It feeds into this whole war on women thing in my head.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Sarah Silverman")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src234"
    }
  }, [_c('a', {
    attrs: {
      "id": "page312"
    }
  }), _c('strong', [_vm._v("I still believe I’m the best player. That’s what keeps me going.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Lisa Leslie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page313"
    }
  }), _vm._v("So many women just don’t know how great they really are. They come to us all vogue outside and vague on the inside.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Mary Kay Ash")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src411"
    }
  }, [_vm._v("Asking what I considered an impossible salary when I didn’t want to work for someone has boosted my pay again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Ethel Waters")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src383"
    }
  }, [_c('a', {
    attrs: {
      "id": "page314"
    }
  }), _vm._v("Nobody needs to prove to anybody what they’re worthy of, just the person that they look at in the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Picabo Street")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text"
  }, [_vm._v("When someone tells you that you are different, smile and hold your head up and be proud.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Angelina Jolie")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('a', {
    attrs: {
      "id": "page315"
    }
  }), _vm._v("I can never be safe; I always try and go against the grain. As soon as I accomplish one thing, "), _c('span', {
    staticClass: "pink"
  }, [_c('em', [_vm._v("I just set a higher goal")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_vm._v("—"), _c('em', [_vm._v("Beyoncé")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white",
    attrs: {
      "id": "src37"
    }
  }, [_c('a', {
    attrs: {
      "id": "page316"
    }
  }), _c('strong', [_vm._v("No matter how difficult and painful it may be, nothing sounds as good to the soul as the truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Martha Beck")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src283"
    }
  }, [_c('a', {
    attrs: {
      "id": "page317"
    }
  }), _vm._v("I think being a woman is like being Irish. Everyone says you’re important and nice, but you take second place all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Iris Murdoch")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/arrow_bul.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text2",
    attrs: {
      "id": "src84"
    }
  }, [_vm._v("There are some people who leave impressions not so lasting as the imprint of an oar upon the water.")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_vm._v("—"), _c('em', [_vm._v("Kate Chopin")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src160"
    }
  }, [_c('a', {
    attrs: {
      "id": "page318"
    }
  }), _vm._v("The thing that drives me most crazy in the world is not to be believed.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Nan Goldin")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src204"
    }
  }, [_vm._v("All issues are women’s issues—and there are several that are just women’s business.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Eddie Bernice Johnson")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_center1 white",
    attrs: {
      "id": "src10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page319"
    }
  }), _vm._v("I take care of my flowers and my cats. And enjoy food. And that’s living.")]), _vm._v(" "), _c('p', {
    staticClass: "auth3 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Ursula Andress")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p"
  }, [_c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src314"
    }
  }, [_c('a', {
    attrs: {
      "id": "page320"
    }
  }), _vm._v("I just love bossy women. I could be around them all day. To me, bossy is not a pejorative term at all. It means somebody’s passionate and engaged and ambitious and doesn’t mind leading.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_c('em', [_vm._v("–Amy Poehler")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src175"
    }
  }, [_vm._v("I learned long ago that there is something worse than missing the goal, and that’s not pulling the trigger.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Mia Hamm")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p"
  }, [_c('p', {
    staticClass: "quote_text1"
  }, [_c('a', {
    attrs: {
      "id": "page321"
    }
  }), _vm._v("Instead of looking at the past, I put myself ahead twenty years and try to look at what I need to do now in order to get there then.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Diana Ross")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/bull_box.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text1",
    attrs: {
      "id": "src117"
    }
  }, [_vm._v("The minute you settle for less than you deserve, you get even less than you settled for.")]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("—"), _c('em', [_vm._v("Maureen Dowd")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote_p"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('a', {
    attrs: {
      "id": "page322"
    }
  }), _c('span', {
    staticClass: "pink"
  }, [_vm._v("What a wonderful life I’ve had! I only wish I’d realized it sooner.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_center"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Colette")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src397"
    }
  }, [_c('a', {
    attrs: {
      "id": "page323"
    }
  }), _vm._v("People always call it luck when you’ve acted more sensibly than they have.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anne Tyler")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src14"
    }
  }, [_vm._v("Nothing is ever the same as they said it was.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Diane Arbus")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b",
    attrs: {
      "id": "src119"
    }
  }, [_c('a', {
    attrs: {
      "id": "page324"
    }
  }), _c('strong', [_vm._v("Be passionate and move forward with gusto every single hour of every single day until you reach your goal.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_vm._v("—"), _c('em', [_vm._v("Ava DuVernay")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p sans"
  }, [_c('p', {
    staticClass: "quote_text_b"
  }, [_c('a', {
    attrs: {
      "id": "page325"
    }
  }), _c('strong', [_c('span', {
    staticClass: "pink"
  }, [_vm._v("It took me quite a long time to develop a voice, and now that I have it, I am not going to be silent")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth_b"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("—"), _c('em', [_vm._v("Madeleine K. Albright")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote1_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src367"
    }
  }, [_c('a', {
    attrs: {
      "id": "page326"
    }
  }), _vm._v("Life is short. People are not easy to know. They’re not easy to know, so if you don’t tell them how you feel, you’re not going to get anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Nina Simone")])]), _vm._v(" "), _c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src318"
    }
  }, [_vm._v("After all those years as a woman hearing “not thin enough, not pretty enough, not smart enough, not this enough, not that enough,” almost overnight I woke up one morning and thought, “I’m enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Anna Quindlen")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote4_p sans"
  }, [_c('p', {
    staticClass: "quote_text",
    attrs: {
      "id": "src140"
    }
  }, [_c('a', {
    attrs: {
      "id": "page327"
    }
  }), _vm._v("You don’t learn from successes; you don’t learn from awards; you don’t learn from celebrity; you only learn from wounds and scars and mistakes and failures. And that’s the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—"), _c('em', [_vm._v("Jane Fonda")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p pink_bg sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page328"
    }
  }), _c('strong', [_vm._v("The truth will set you free, but first it will piss you off.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Gloria Steinem")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote2_p black sans"
  }, [_c('p', {
    staticClass: "quote_text_b1 white"
  }, [_c('a', {
    attrs: {
      "id": "page329"
    }
  }), _c('strong', [_vm._v("Despite all the challenges we face, I remain convinced that yes, the future is female.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1_b1 white"
  }, [_vm._v("—"), _c('em', [_vm._v("Hillary Clinton")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df8a6d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454927839_epub_c01_r1.vue
// module id = 72
// module chunks = 0